import { isServiceRow } from '../../utils/nsmpRowTypes';
import { getIntegracaoStatus, isDigitadoSemIntegracaoSync } from './integracaoStatus';

const serviceRows = (nsmps) => (nsmps || []).filter(isServiceRow);

const pickServerResumo = (serverResumo, mode) => {
  if (!serverResumo) return null;
  if (mode === 'CONSULTA') {
    return {
      meusDigitados: serverResumo.meusDigitados,
      meusIntegrados: serverResumo.meusIntegrados,
      meusErroIntegracao: serverResumo.meusErroIntegracao,
    };
  }
  return {
    totalServicos: serverResumo.totalServicos,
    digitados: serverResumo.digitados,
    pendentes: serverResumo.pendentes,
    integradas: serverResumo.integradas,
    erroIntegracao: serverResumo.erroIntegracao,
    digitadoSemIntegracao: serverResumo.digitadoSemIntegracao,
  };
};

export const computeResumoNsir = (nsmps, { userId, mode, serverResumo } = {}) => {
  const rows = serviceRows(nsmps);
  const total = rows.length;
  const digitados = rows.filter((r) => r.tipoServico).length;
  const pendentes = Math.max(0, total - digitados);
  const integradas = rows.filter((r) => getIntegracaoStatus(r) === 'SYNCED').length;
  const erroIntegracao = rows.filter((r) => getIntegracaoStatus(r) === 'ERROR_SYNC').length;
  const digitadoSemIntegracao = rows.filter((r) => isDigitadoSemIntegracaoSync(r)).length;

  const base = {
    totalServicos: total,
    digitados,
    pendentes,
    integradas,
    erroIntegracao,
    digitadoSemIntegracao,
  };

  const fromServer = pickServerResumo(serverResumo, mode);
  const mergedBase = fromServer
    ? { ...base, ...Object.fromEntries(Object.entries(fromServer).filter(([, v]) => v != null)) }
    : base;

  if (mode !== 'CONSULTA' || !userId) {
    return mergedBase;
  }

  const mine = rows.filter((r) => rowIsMine(r, userId));
  const consultaLocal = {
    ...mergedBase,
    meusDigitados: mine.length,
    meusIntegrados: mine.filter((r) => getIntegracaoStatus(r) === 'SYNCED').length,
    meusErroIntegracao: mine.filter((r) => getIntegracaoStatus(r) === 'ERROR_SYNC').length,
  };

  if (!fromServer) return consultaLocal;

  return {
    ...consultaLocal,
    ...Object.fromEntries(
      Object.entries(fromServer).filter(([, v]) => v != null),
    ),
  };
};

export const rowIsMine = (row, userId) => {
  if (!row || !userId) return false;
  if (row.minhaDigitacao?.temEvento) return true;
  if (row.resumoDigitacao?.ultimoDigitadorId === userId) return true;
  if (row.resumoDigitacao?.digitadorId === userId) return true;
  return false;
};

export default computeResumoNsir;
